import { render, staticRenderFns } from "./AssetComponentCommandsModal.vue?vue&type=template&id=0712fe63&"
import script from "./AssetComponentCommandsModal.vue?vue&type=script&lang=js&"
export * from "./AssetComponentCommandsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports